// @flow
import { styled } from 'mz-ui-kit'

const getIconStyles = ($disabled) => ({
  marginRight: '5px',
  opacity: $disabled ? 0.6 : 1,
})

export const Controls = styled('div', {
  display: 'flex',
  flexFlow: 'row nowrap',
  alignItems: 'center',
})

export const InputControl = styled<{
  $disabled?: boolean,
}>('div', ({ $disabled, $palette }) => ({
  cursor: 'pointer',
  fontSize: '18px',
  color: `${$palette('PRIMARY')}`,
  ...getIconStyles($disabled),
}))
